import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import IMedia from 'models/Media';
import { deleteMedia, getMedia, uploadMedia } from './mediaAsync';

interface IState {
  media: IMedia[];
  selectedMedia: IMedia | null;
};

const initialState:IState = {
  media: [],
  selectedMedia: null
};

const slice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setSelectedMedia: (state:IState, action:PayloadAction<IMedia>) => {
      state.selectedMedia = action.payload;
    },
    setInitialField: <IStateKey extends keyof IState>(state:IState, action:PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMedia.fulfilled, (state, action:PayloadAction<IMedia[]>) => {
      state.media = action.payload;
    });
    builder.addCase(uploadMedia.fulfilled, (state, action:PayloadAction<IMedia>) => {
      state.media = [...state.media, action.payload];
    });
    builder.addCase(deleteMedia.fulfilled, (state, action:PayloadAction<any>) => {
      state.media = state.media.filter(m => m._id !== action.payload);
      if (state.selectedMedia?._id === action.payload) state.selectedMedia = null;
    });
  }
});

export const mediaActions = slice.actions;

export default slice.reducer;
